import { render, staticRenderFns } from "./QuizCreator.vue?vue&type=template&id=3ddc5c6c"
import script from "./QuizCreator.vue?vue&type=script&lang=js"
export * from "./QuizCreator.vue?vue&type=script&lang=js"
import style0 from "./QuizCreator.vue?vue&type=style&index=0&id=3ddc5c6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports